import React, { useEffect, useRef, useState } from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { photoExtensions } from '../../constants/general';
import { isBrowser } from 'react-device-detect';
import spinner from '../../style/img/ajax-loader.svg';
import styles from './index.module.scss';

const {
  photoContainer,
  flipCard,
  flipped,
  front,
  back,
  iconPhoto,
  titlePhoto,
  photoButton,
  buttonBack,
} = styles;

const AccionaPhoto = ({ onChange, label, loading, isSelectable }) => {
  const intl = useIntl();
  const inputFileRef = useRef(null);
  const [isFlipped, setIsFlipped] = useState(false);
  const [captureMode, setCaptureMode] = useState(null);
  const [isPc, setIsPc] = useState();

  useEffect(() => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const isLikelyMobileOrTablet =
      hasTouch && (screenWidth < 1024 || screenHeight < 768);

    setIsPc(isBrowser && !isLikelyMobileOrTablet);
  }, []);

  const numberRandom = Math.floor(Math.random() * 10000) + 1;

  const onFilechange = ({ target }) => {
    if (target.files?.length) {
      if (validationPhotoExtension(target.files[0].type)) {
        onChange([...target?.files]);
        setIsFlipped(false);
        setCaptureMode('initial');
      } else {
        alert('Formato de fichero no soportado');
      }
    }
  };

  const validationPhotoExtension = (photo) => {
    return photoExtensions.includes(photo.split('/')[1]);
  };

  const handleMainButtonUpload = () => {
    if ((isPc || !isSelectable) && inputFileRef.current) {
      inputFileRef.current.click();
    } else {
      setIsFlipped(true);
    }
  };

  useEffect(() => {
    if (captureMode && captureMode !== 'initial') {
      if (inputFileRef.current) {
        inputFileRef.current.click();
      }
      setCaptureMode(null);
    }
  }, [captureMode]);

  return (
    <div className={photoContainer}>
      <input
        id={`imgInput${numberRandom}`}
        type="file"
        accept="image/jpg, image/jpeg, image/png"
        style={{ display: 'none' }}
        ref={inputFileRef}
        onChangeCapture={onFilechange}
        capture={
          captureMode === 'camera' || !isSelectable ? 'environment' : undefined
        }
      />

      <div
        className={`${flipCard} ${isFlipped && !isPc && isSelectable ? flipped : ''}`}
      >
        <div className={front}>
          <button
            className={photoButton}
            onClick={() => handleMainButtonUpload()}
          >
            {loading ? (
              <img src={spinner} height="64" width="64" alt="Loading" />
            ) : (
              <i
                className={`icon fas fa-${isPc || !isSelectable ? 'image' : 'cloud-upload-alt'} ${iconPhoto}`}
              />
            )}
            {label && (
              <p className={titlePhoto}>{intl.formatMessage({ id: label })}</p>
            )}
          </button>
        </div>
        <div className={back}>
          <button
            className={`${photoButton} ${buttonBack}`}
            onClick={() => setCaptureMode('camera')}
          >
            <i className={`fas fa-camera ${iconPhoto}`} />
            <p className={titlePhoto}>
              {intl.formatMessage({ id: 'optionImage.camera' })}
            </p>
          </button>
          <button
            className={`${photoButton} ${buttonBack}`}
            onClick={() => setCaptureMode('gallery')}
          >
            <i className={`fas fa-image ${iconPhoto}`} />
            <p className={titlePhoto}>
              {intl.formatMessage({ id: 'optionImage.gallery' })}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

AccionaPhoto.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  loading: PropTypes.bool,
  isSelectable: PropTypes.bool,
};

AccionaPhoto.defaultProps = {
  label: undefined,
  loading: false,
  isSelectable: false,
};

export default injectIntl(AccionaPhoto);
